import React, { useState, useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import style from './orders.module.scss';
import Button from "../../Components/Button/button";
import OrderCard from './orderCard/orderCard'
import MobileOrderCard from './mobileOrderCard/mobileOrderCard'
import DatePickerDropdown from './datePickerDropdown/datePickerDropdown'
import Searchbar from "../productSearchbar/productSearchbar";
import Dropdown from "../../Components/Dropdown/RealTimeButtonDropDown/DropDown";
import Pagination from "../pagination/pagination"
import MobilePagination from "../mobilePagination/mobilePagination"
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import toPersianNumber from '../../helpers/actions/toPersianNumber'
import Skeleton from "../variantList/skeleton"
import { GetOrderList, GetSellers } from "../../actions/APIcalls"
import noVariantEmptyState from '../../assets/icons/EmptyStates/variant_noactivevariant.svg'
import moment from "moment-jalaali";

const Orders = (props) => {
    const [orderData, setOrderData] = useState({
        orderList: [],
        rangeFilters: {
            order_item_created_at: {
                index: 0,
                name: "تاریخ ثبت سفارش",
                openModal: false,
                from: '',
                to: ''
            },
            warehouse_status_at: {
                index: 1,
                name: "تاریخ ثبت نهایی",
                openModal: false,
                from: '',
                to: ''
            },
            commitment_date: {
                index: 2,
                name: "تاریخ تعهد ارسال",
                openModal: false,
                from: '',
                to: ''
            },
        },
        range_type: [{ name: "تاریخ ثبت سفارش", checked: false, tag: "order_item_created_at", index: 0, }, { name: "تاریخ ثبت نهایی", checked: false, tag: "warehouse_status_at", index: 1, }, { name: "تاریخ تعهد ارسال", checked: false, tag: "commitment_date", index: 2, },],
        is_commited: [{ name: "تعهد ارسال دارد", tag: "isCommited", checked: false, index: 0, value: 'true' }, { name: "تعهد ارسال ندارد", tag: "isNotCommited", checked: false, index: 1, value: 'false' }],
        sellers: [],
        orderCount: 0,
        totalPages: 1,
        page: 1,
        countInPage: 10
    })
    const [skeleton, setSkeleton] = useState(true)
    const [locationKeys, setLocationKeys] = useState([])
    const history = useHistory()

    // handle back and forward 
    useEffect(() => {
        return history.listen(location => {
            if (history.action === 'PUSH') {
                setLocationKeys([location.key])
            }
            if (history.action === 'POP') {
                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)
                    // Handle forward event
                    getOrders();
                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    // Handle back event
                    getOrders();
                }
            }
        })
    }, [locationKeys,])
    // end handle back and forward 
    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    useEffect(async () => {
        await getSellers()
        await setFilters()
        await getOrders()
    }, [])

    const setFilters = () => {
        let urlFilters = getFilters()
        let tmpData = orderData

        Object.keys(urlFilters).map(key => {
            if (key.includes('_from')) {
                let tmp = key.slice(0, key.indexOf('_from'))
                tmpData.rangeFilters[tmp].from = urlFilters[key]
            }
            if (key.includes('_to')) {
                let tmp = key.slice(0, key.indexOf('_to'))
                tmpData.rangeFilters[tmp].to = urlFilters[key]
                tmpData.range_type.map(el => {
                    if (el.tag == tmp) {
                        el.checked = true
                    }
                })
            }
            if (key == 'channels') {
                tmpData.sellers.map(el => {
                    if (urlFilters[key].includes(el.name)) {
                        el.checked = true
                    }
                })
            }
            if (key == 'is_commited') {
                tmpData.is_commited.map(el => {
                    if (el.value == String(urlFilters[key])) {
                        el.checked = true
                    }
                })
            }
        })

        setOrderData({ ...tmpData })
    }

    const getFilters = () => {
        let tmpUrlFilters = {
            order_item_created_at_from: getFromUrl('order_item_created_at_from') ? getFromUrl('order_item_created_at_from') : '',
            order_item_created_at_to: getFromUrl('order_item_created_at_to') ? getFromUrl('order_item_created_at_to') : '',
            warehouse_status_at_from: getFromUrl('warehouse_status_at_from') ? getFromUrl('warehouse_status_at_from') : '',
            warehouse_status_at_to: getFromUrl('warehouse_status_at_to') ? getFromUrl('warehouse_status_at_to') : '',
            commitment_date_from: getFromUrl('commitment_date_from') ? getFromUrl('commitment_date_from') : '',
            commitment_date_to: getFromUrl('commitment_date_to') ? getFromUrl('commitment_date_to') : '',
            channels: getFromUrl('sellers') ? getFromUrl('sellers') : '',
            is_commited: (getFromUrl('is_commited')).toString() ? (getFromUrl('is_commited')).toString() : 'both',
            sort_by: getFromUrl('sort_by') ? getFromUrl('sort_by') : 'commitment_date',
            order_by: 'desc',
            countInPage: getFromUrl('countInPage') ? getFromUrl('countInPage') : 10,
            page: getFromUrl('page') ? getFromUrl('page') : 1,
            q: getFromUrl('query')
        }
        Object.keys(tmpUrlFilters).map(key => {
            if (tmpUrlFilters[key] == '') {
                delete tmpUrlFilters[key];
            }
        })
        return tmpUrlFilters
    }

    const selectHandler = (tag, value) => {
        let tmp = orderData
        if (tag == 'range_type') {
            tmp[tag].map(el => {
                if (el.tag == value.tag) {
                    el.checked = !value.checked
                } else {
                    el.checked = false
                }
                if (!el.checked) {
                    // delete from url
                    deleteFromUrl(`${el.tag}_from`)
                    deleteFromUrl(`${el.tag}_to`)
                }
            })
        } else {
            if (tag == 'is_commited') {
                tmp[tag].map(el => el.checked = false)
                tmp[tag][value.index].checked = !value.checked
                if (!value.checked) {
                    deleteFromUrl(tag)
                } else {
                    setToUrl(value.value, tag)
                }
            }
            if (tag == 'sellers') {
                tmp[tag][value.index].checked = !value.checked
                let selectedSellers = []
                tmp[tag].map(el => {
                    if (el.checked) {
                        selectedSellers.push(el.name)
                    }
                })
                if (selectedSellers.length > 0) {
                    setToUrl(selectedSellers, 'sellers')
                } else {
                    deleteFromUrl('sellers')
                }
            }
        }
        setOrderData({ ...tmp })
        // handle is_commited toggle
    }

    const getSellers = async () => {
        // get user's channel
        let channels = await GetSellers()
        if (channels && channels.data && channels.data.channelList) {
            let tmp = orderData
            tmp.sellers = channels.data.channelList
            tmp.sellers.map((el, index) => { el.checked = false; el.index = index })
            setOrderData({ ...tmp })
        }
    }

    const convertToId = (selectedArr, mainArr) => {
        let tmpIdsArr = []
        mainArr.map(el => {
            if (selectedArr.includes(el.name)) {
                tmpIdsArr.push(el._id)
            }
        })
        return tmpIdsArr
    }

    const getOrders = async () => {
        // get all orders
        setSkeleton(true)
        let params = getFilters()
        if (params.channels) {
            params.channels = convertToId(params.channels, orderData.sellers)
        }
        let res = await GetOrderList(params)
        if (res && res.data && res.data.success) {
            let tmp = orderData
            tmp.orderList = res.data.data
            tmp.totalPages = res.data.totalPages
            tmp.orderCount = res.data.orderCount
            setOrderData({ ...tmp })
        }
        setSkeleton(false)
    }

    const pageSetter = number => {
        setToUrl(number, 'page')
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            if (value.from && value.to) {
                url.set(param + '_from', value.from);
                url.set(param + '_to', value.to);
            } else {
                url.set(param, value);
            }
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        getOrders();
    }

    const getFromUrl = (param) => {
        const defaultParams = {
            order_item_created_at_from: '',
            order_item_created_at_to: '',
            warehouse_status_at_from: '',
            warehouse_status_at_to: '',
            commitment_date_from: '',
            commitment_date_to: '',
            sellers: [],
            is_commited: 'both',
            sort_by: 'commitment_date',
            order_by: 'desc',
            countInPage: 10,
            page: 1,
            query: ""
        }
        let url = new URLSearchParams(window.location.search);
        if (url.get(param)) {
            if (param === "sellers") {
                return url.get(param).split("*");
            } else {
                if (url.get(param) === "true" || url.get(param) === "false") {
                    return url.get(param) === "true" ? true : false;
                } else {
                    return url.get(param)
                }
            }
        } else {
            return defaultParams[param];
        }
    }

    const deleteFromUrl = (param) => {
        let url = new URLSearchParams(window.location.search);
        url.delete(param);
        props.history.push(window.location.pathname + "?" + url.toString());
        // delete from state
    }

    const exportRange = (rangeFilter, range) => {
        let tmp = orderData
        if (range.start && range.end) {
            tmp.rangeFilters[rangeFilter].from = moment(range.start).toISOString();
            tmp.rangeFilters[rangeFilter].to = moment(range.end).toISOString();
        }
        if (range.start && !range.end) {
            tmp.rangeFilters[rangeFilter].from = moment(range.start).toISOString();
            tmp.rangeFilters[rangeFilter].to = moment(range.start).toISOString();
        }
        setOrderData({ ...tmp })
        setToUrl(tmp.rangeFilters[rangeFilter], rangeFilter)
    }

    const deleteRange = filter => {
        // delete from and to
        let tmp = orderData
        tmp.rangeFilters[filter].from = ''
        tmp.rangeFilters[filter].to = ''
        deleteFromUrl(`${filter}_from`)
        deleteFromUrl(`${filter}_to`)
        setOrderData({ ...tmp })
    }

    const resetFilters = () => {
        let tmp = orderData
        let checkedFilters = ['rangeFilters', 'is_commited', 'range_type', 'sellers']
        checkedFilters.map(filter => {
            if (filter == 'rangeFilters') {
                Object.keys(tmp.rangeFilters).map(el => {
                    tmp.rangeFilters[el].from = ''
                    tmp.rangeFilters[el].to = ''
                })
            } else {
                tmp[filter].map(insideFilter => {
                    insideFilter.checked = false
                })
            }
        })
        setOrderData({ ...tmp })
    }

    const deleteAllFiletrs = async () => {
        resetFilters()
        props.history.push(window.location.pathname)
        await getOrders()
    }

    const deleteFromDropdown = (tag) => {
        let tmp = orderData
        tmp[tag].map(el => {
            el.checked = false
            if (tag == 'range_type') {
                deleteFromUrl(`${el.tag}_from`)
                deleteFromUrl(`${el.tag}_to`)
            } else {
                deleteFromUrl(tag)
            }
        })
        setOrderData({ ...tmp })
    }

    const urlChecker = () => {
        let result = false;
        const defaultParams = getFilters()
        if ((defaultParams.order_item_created_at_from && defaultParams.order_item_created_at_to) || (defaultParams.warehouse_status_at_from && defaultParams.warehouse_status_at_from)
            || (defaultParams.commitment_date_from && defaultParams.commitment_date_from) || ((defaultParams.is_commited).toString() == 'true') || ((defaultParams.is_commited).toString() == 'false') ||
            (defaultParams.channels) || (defaultParams.sort_by != 'commitment_date')) {
            result = true
        }
        return result
    }

    const searchHandler = (value) => {
        setToUrl(value, 'query')
    }

    const emptyRenderer = () => {
        return <div className={style.empty}>
            <React.Fragment>
                <div className={style.image}>
                    <img src={noVariantEmptyState} />
                </div>
                <p>در حال حاضری سفارشی با فیلترهای انتخابی وجود ندارد</p>
                <p className={style.boldText}>لطفا فیلترهای انتخابی خود را تغییر دهید</p>
                <Button type="solid"
                    label={"بازگشت به صفحه قبل"}
                    onclick={() => props.history.goBack()}
                />
            </React.Fragment>
        </div>
    }

    if (skeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <div className={style.header}>
                    <h1 className={style.title}>سفارشات</h1>
                    <div className={style.settingButton}>
                        <Button
                            disabled={false}
                            tag="cargo"
                            type="solid"
                            label="ساخت خودکار محموله"
                            onclick={() => props.history.push('/cargo')}
                        />
                    </div>
                </div>
                <div className={style.searchWrapper}>
                    <Searchbar
                        placeholder={"عنوان یا کد کالا یا کد تنوع"}
                        value={getFromUrl("query") ? getFromUrl("query") : ''}
                        searchValue={(value) => searchHandler(value)}
                    />
                </div>

                <div className={style.filterWrapper}>
                    {urlChecker() && <div
                        className={style.deleteAll}
                        onClick={() => deleteAllFiletrs()}
                    >
                        <span className={style.icon}>g</span>
                    </div>}
                    <Dropdown
                        tag={'range_type'}
                        label={'بازه زمانی بر اساس'}
                        placeHolder={'بازه زمانی بر اساس'}
                        dropdownList={orderData.range_type}
                        hasCheckbox={true}
                        handleSelect={selectHandler}
                        deleteSelectedItems={deleteFromDropdown}
                        action={getOrders}
                    />
                    {orderData.range_type.filter(el => el.checked).length > 0 && <>
                        <DatePickerDropdown
                            rangeIndex={orderData.range_type.filter(el => el.checked)[0].index}
                            rangeItem={orderData.range_type.filter(el => el.checked)[0].tag}
                            rangeFilters={orderData.rangeFilters}
                            exportRange={exportRange}
                            value={{ start: orderData.rangeFilters[orderData.range_type.filter(el => el.checked)[0].tag].from, end: orderData.rangeFilters[orderData.range_type.filter(el => el.checked)[0].tag].to }}
                            deleteRange={deleteRange}
                        />
                    </>}
                    <Dropdown
                        tag={'is_commited'}
                        label={'تعهد ارسال'}
                        placeHolder={'تعهد ارسال'}
                        dropdownList={orderData.is_commited}
                        hasCheckbox={true}
                        handleSelect={selectHandler}
                        deleteSelectedItems={deleteFromDropdown}
                        action={getOrders}
                    />
                    {orderData.sellers.length > 1 && <Dropdown
                        tag='sellers'
                        label='فروشنده'
                        placeHolder='فروشنده'
                        dropdownList={orderData.sellers}
                        hasCheckbox={true}
                        deleteSelectedItems={deleteFromDropdown}
                        handleSelect={selectHandler}
                        action={getOrders}
                    />}
                </div>

                {orderData.orderList.length > 0 ? <>
                    <div className={style.paginationRow}>
                        <div className={style.pagination}>
                            <div className={style.Dropdown}>
                                <Pagination
                                    currentPage={getFromUrl('page') ? getFromUrl('page') : orderData.page}
                                    pageCount={orderData.totalPages}
                                    setPage={pageSetter}
                                />
                                <TinyDropdown
                                    placeholder={getFromUrl('countInPage')}
                                    dropdownList={["10", "25", "50", "75", "100"]}
                                    selected={selected => {
                                        let page = { ...orderData };
                                        page.countInPage = selected;
                                        setOrderData({ ...page })
                                        setToUrl(selected, 'countInPage')
                                        getOrders()
                                    }} />
                                <div className={style.label}>تعداد نمایش در صفحه</div>
                                <div className={style.verticalLine}></div>
                                <div className={style.variantCount}>{toPersianNumber(orderData.orderCount) + " سفارش "}</div>
                            </div>
                        </div>
                    </div>

                    {/* List */}
                    <div className={style.desktopTable}>
                        <div className={style.hiddenListShadow}></div>
                        <div className={style.logListWrapper}>
                            <div
                                className={offset > 480 ? style.listHeaderFixed : style.listHeader}
                                style={offset > 480 && (sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') ? { width: 'calc(100% - 140px)' } : (offset > 480 ? { width: 'calc(100% - 280px)' } : null)}
                            >
                                <div className={style.listHeaderItem278}>مشخصات کالا</div>
                                <div className={style.listHeaderItem96}>DKPC<span onClick={() => setToUrl('dkpc', 'sort_by')} className={style.sortIcon}>p</span></div>
                                <div className={style.listHeaderItem144}><span>تاریخ ثبت سفارش</span><span onClick={() => setToUrl('order_item_created_at', 'sort_by')} className={style.sortIcon}>p</span></div>
                                <div className={style.listHeaderItem144}><span>تاریخ ثبت نهایی</span><span onClick={() => setToUrl('warehouse_status_at', 'sort_by')} className={style.sortIcon}>p</span></div>
                                <div className={style.listHeaderItem144}><span>تاریخ تعهد ارسال</span><span onClick={() => setToUrl('commitment_date', 'sort_by')} className={style.sortIcon}>p</span></div>
                                <div className={style.listHeaderItem96}>تعداد سفارش</div>
                                <div className={style.listHeaderItem96}>تعداد تعهد ارسال</div>
                            </div>
                            <div className={offset > 480 ? style.hiddenListHeader : ''}></div>
                            <div className={style.listWrapper}>
                                {orderData.orderList ? orderData.orderList.map((listItem, index) => <div key={`orderList_${index}`}>
                                    <OrderCard
                                        key={index}
                                        data={listItem}
                                    />
                                </div>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {/* Mobile Table */}
                    <div className={style.mobileTable}>
                        {orderData.orderList ? orderData.orderList.map((listItem, index) => <div key={`mobileOrderList_${index}`}>
                            <MobileOrderCard
                                key={index}
                                data={listItem}
                            />
                        </div>
                        ) : null}
                    </div>

                    {/* second pagination */}
                    <div className={style.mobilePagination}>
                        <MobilePagination
                            currentPage={getFromUrl('page') ? getFromUrl('page') : orderData.page}
                            pageCount={orderData.totalPages}
                            setPage={pageSetter}
                        />
                    </div>
                    <div className={style.paginationTwo}>
                        <Pagination
                            currentPage={getFromUrl('page') ? getFromUrl('page') : orderData.page}
                            pageCount={orderData.totalPages}
                            setPage={pageSetter}
                        />
                    </div>
                    {/* second pagination  */}
                </>
                    :
                    <>
                        {emptyRenderer()}
                    </>
                }
            </div>
        )
    }
}
export default withRouter(Orders)